export const AUTH_ACTIONS = {
  SET_USER_ACTION: "SET_USER_ACTION",
};

export const SET_USER_ACTION = {
  SET_USER_ACTION_REQUEST: "SET_USER_ACTION_REQUEST",
  SET_USER_ACTION_SUCCESS: "SET_USER_ACTION_SUCCESS",
  SET_USER_ACTION_FAILURE: "SET_USER_ACTION_FAILURE",
};
